import actionTypes from './formTemplates.actionTypes';
import firstBy from 'thenby';


const initialState = {
  companyId: '',
  employeeId: '',
  isLoading: false,
  templates: [],
  defaultTemplates: [],
};


export default function (state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_FORM_TEMPLATES_BEGIN: return fetchFormTemplatesBegin(state, action);
    case actionTypes.FETCH_FORM_TEMPLATES_SUCCESS: return fetchFormTemplatesSuccess(state, action);
    case actionTypes.FETCH_FORM_TEMPLATES_FAILURE: return fetchFormTemplatesFailure(state);

    case actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_BEGIN: return fetchDefaultFormTemplatesBegin(state, action);
    case actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_SUCCESS: return fetchDefaultFormTemplatesSuccess(state, action);
    case actionTypes.FETCH_DEFAULT_FORM_TEMPLATES_FAILURE: return fetchDefaultFormTemplatesFailure(state);

    default:
      return state;
  }
}

const fetchFormTemplatesBegin = (state, { payload }) => {
  return {
    ...state,
    isLoading: true,
    companyId: payload.companyId,
    employeeId: payload.employeeId,
  };
};

const fetchFormTemplatesSuccess = (state, action) => {
  let templates = action.data;

  let sorting = { field: "name", direction: "asc" };
  let sortedTemplates = sortTemplates(sorting, templates);

  let defaultTemplates = dedupeDefaultTemplatesByName(sortedTemplates.filter(x => {
    return x.isDefaultTemplate === true;
  }));

  return {
    ...state,
    isLoading: false,
    templates: [...templates],
    defaultTemplates: [...defaultTemplates]
  };
};

const fetchFormTemplatesFailure = state => {
  return {
    ...state,
    isLoading: false
  };
};


const fetchDefaultFormTemplatesBegin = (state, { payload }) => {
  return {
    ...state,
    isLoading: true,
    companyId: payload.companyId,
    employeeId: payload.employeeId,
  };
};

const fetchDefaultFormTemplatesSuccess = (state, action) => {
  let templates = action.data;

  let sorting = { field: "name", direction: "asc" };
  let sortedTemplates = sortTemplates(sorting, templates);

  let defaultTemplates = dedupeDefaultTemplatesByName(sortedTemplates.filter(x => {
    return x.isDefaultTemplate === true;
  }));

  return {
    ...state,
    isLoading: false,
    defaultTemplates: [...defaultTemplates]
  };
};

// If more than one default template shares the same name (an old and a newer version of the same
// default template both still exist), only show one - otherwise the dropdown lists indistinguishable
// duplicates. The TalentForms API already returns just the version toggle 76132 selects for the
// company; this is a safety net in case both versions still come back. Highest templateVersion wins
// (missing = 1), then newest createdDate, then highest id.
const dedupeDefaultTemplatesByName = (templates) => {
  const newestByName = new Map();

  templates.forEach(template => {
    const existing = newestByName.get(template.templateName);
    if (!existing || isNewerTemplate(template, existing)) {
      newestByName.set(template.templateName, template);
    }
  });

  return templates.filter(template => newestByName.get(template.templateName) === template);
};

const templateVersionOf = (template) => template.templateVersion || 1;

const isNewerTemplate = (candidate, current) => {
  const candidateVersion = templateVersionOf(candidate);
  const currentVersion = templateVersionOf(current);

  if (candidateVersion !== currentVersion) {
    return candidateVersion > currentVersion;
  }

  const candidateDate = candidate.createdDate ? new Date(candidate.createdDate).getTime() : 0;
  const currentDate = current.createdDate ? new Date(current.createdDate).getTime() : 0;

  if (candidateDate !== currentDate) {
    return candidateDate > currentDate;
  }

  return (candidate.id || 0) > (current.id || 0);
};

const fetchDefaultFormTemplatesFailure = state => {
  return {
    ...state,
    isLoading: false
  };
};

const sortTemplates = (sorting, templates) => {
  let field = "name";
  let direction = "desc";

  let workingArray = [...templates];
  if (field && direction) {
    workingArray.sort(firstBy(sorting.field, sorting.direction === 'desc' ? -1 : undefined));
  }

  return workingArray;
};
